import { AxiosResponse } from "axios";
import {
  SET_OPPORTUNITY_CONTACTS,
  SET_OPPORTUNITY_CONTACT,
  SET_ERRORMSG,
} from "@/store/mutation-types";
import {
  CLEAR_OPPORTUNITY_CONTACT_ISLOADING,
  DELETE_OPPORTUNITY_CONTACT,
  EDIT_OPPORTUNITY_CONTACT,
  GET_OPPORTUNITY_CONTACTS,
  REGISTER_OPPORTUNITY_CONTACT,
} from "@/store/action-types";
import { StateObject } from "@/dtos/State.dto";
import OpportunityContact from "@/services/opportunity/opportunity-contact";
import { Module } from "vuex";
import {
  EditOpportunityContact,
  RegisterOpportunityContact,
  GetOpportunityContact,
} from "@/dtos/OpportunityContact.dto";

const opportunityContact: Module<any, {}> = {
  state: {
    opportunityContact: {
      data: null,
      isLoading: false,
    },
    opportunityContacts: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    opportunityContact: (state: { opportunityContact: any }) => state.opportunityContact,
    opportunityContacts: (state: { opportunityContacts: any }) => state.opportunityContacts,
  },
  mutations: {
    [SET_OPPORTUNITY_CONTACT]: (
      state: { opportunityContact: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.opportunityContact.data = payload.data;
      state.opportunityContact.isLoading = payload.isLoading;
    },
    [SET_OPPORTUNITY_CONTACTS]: (
      state: { opportunityContacts: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.opportunityContacts.data = payload.data;
      state.opportunityContacts.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_OPPORTUNITY_CONTACT]: async ({ commit }: any, payload: any) => {
      commit(SET_OPPORTUNITY_CONTACT, { data: null, isLoading: true });

      const result: AxiosResponse = await OpportunityContact.registerOpportunityContact(
        payload as RegisterOpportunityContact
      );

      if (result) {
        if (result.data.status) {
          commit(SET_OPPORTUNITY_CONTACT, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_OPPORTUNITY_CONTACT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OPPORTUNITY_CONTACT, { isLoading: false });
        return false;
      }
    },
    [GET_OPPORTUNITY_CONTACTS]: async ({ commit }: any, payload: any) => {
      commit(SET_OPPORTUNITY_CONTACTS, { isLoading: true });

      const result: AxiosResponse = await OpportunityContact.getOpportunityContacts(
        payload as GetOpportunityContact
      );

      if (result) {
        if (result.data.status) {
          commit(SET_OPPORTUNITY_CONTACTS, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_OPPORTUNITY_CONTACTS, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OPPORTUNITY_CONTACTS, { isLoading: false });
        return false;
      }
    },
    [EDIT_OPPORTUNITY_CONTACT]: async ({ commit }: any, payload: any) => {
      commit(SET_OPPORTUNITY_CONTACT, { data: null, isLoading: true });

      const result: AxiosResponse = await OpportunityContact.editOpportunityContact(
        payload as EditOpportunityContact
      );

      if (result) {
        if (result.data.status) {
          commit(SET_OPPORTUNITY_CONTACT, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_OPPORTUNITY_CONTACT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OPPORTUNITY_CONTACT, { isLoading: false });
        return false;
      }
    },
    [DELETE_OPPORTUNITY_CONTACT]: async ({ commit }: any, payload: string) => {
      commit(SET_OPPORTUNITY_CONTACT, {
        data: { id: payload },
        isLoading: true,
      });

      const result: AxiosResponse = await OpportunityContact.deleteOpportunityContact(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_OPPORTUNITY_CONTACT, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_OPPORTUNITY_CONTACT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OPPORTUNITY_CONTACT, { isLoading: false });
        return false;
      }
    },
    [CLEAR_OPPORTUNITY_CONTACT_ISLOADING]: ({ commit }) => {
      commit(SET_OPPORTUNITY_CONTACT, { isLoading: false });
      commit(SET_OPPORTUNITY_CONTACTS, { isLoading: false });
    },
  },
};

export default opportunityContact;
